import axios from 'axios';
import { API_URL } from '../config/api';

/**
 * Notification Service
 *
 * Wraps /api/notifications calls with the user's auth token. Every request
 * was previously sent with no Authorization header, which produced 401s
 * across the board and made the bell appear permanently broken — the
 * helper below adds the header to every call.
 */

const API_BASE = API_URL;

// Build a fresh header set on each call (the token can change after login)
const authHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const notificationService = {
  getAll: async (unreadOnly = false, limit = 50) => {
    const response = await axios.get(`${API_BASE}/notifications`, {
      params: { unreadOnly, limit },
      headers: authHeaders()
    });
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await axios.get(`${API_BASE}/notifications/unread-count`, {
      headers: authHeaders()
    });
    return response.data.count;
  },

  markAsRead: async (notificationId) => {
    const response = await axios.put(
      `${API_BASE}/notifications/${notificationId}/read`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await axios.put(
      `${API_BASE}/notifications/mark-all-read`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  },

  markManyAsRead: async (notificationIds) => {
    const response = await axios.put(
      `${API_BASE}/notifications/mark-many-read`,
      { notificationIds },
      { headers: authHeaders() }
    );
    return response.data;
  },

  delete: async (notificationId) => {
    await axios.delete(`${API_BASE}/notifications/${notificationId}`, {
      headers: authHeaders()
    });
  },

  deleteAllRead: async () => {
    const response = await axios.delete(`${API_BASE}/notifications/read`, {
      headers: authHeaders()
    });
    return response.data;
  }
};

export default notificationService;
